import React, { Component }          from 'react';
import Select                        from 'react-select'
import { ROLES }                     from '../../common/Common';

import icClose                       from '../../../img/ic_close.svg';

import "./Dialog.scss";

class AdminDialog extends Component {

  constructor(props) {
    super(props);

    this.state            = {
      email: '',
      firstName: '',
      lastName: '',
      role: '',
      exhibits: [],
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      if (this.props.editingAdmin) {
        this.setState({
          email: this.props.editingAdmin.email,
          firstName: this.props.editingAdmin.firstName,
          lastName: this.props.editingAdmin.lastName,
          role: this.props.editingAdmin.role,
          exhibits: this.buildExhibitsFromIds(this.props.editingAdmin),
        })
      } else if (!this.props.editingAdmin) {
        console.log('SET EDITING ADMIN')
        this.setState({
          email: '',
          firstName: '',
          lastName: '',
          role: ROLES.VIEWER,
          exhibits: [],
        })
      }
    }
  }

  buildExhibitsFromIds(admin) {
    if (admin.role === "ADMIN") {
      return []
    } else {
      let exhibits = [];  
      for (let i = 0; i < admin.exhibitIds.length; i++) {
        let exhibit = this.props.locations.find(e => e.id === admin.exhibitIds[i]);
        if (exhibit) {
          exhibits.push({value: exhibit.id, label: `${exhibit.name} - ${exhibit.city}`});
        }
      }
      return exhibits;
    }
  }

  onFieldChange(name, event) {
    if (name === 'email' && this.props.editingAdmin) {
      return;
    }
    this.setState({[name]: event.target.value});
  }

  onMultiSelectChange(name, data) {
    this.setState({[name]: data});
  }

  getTitleText() {
    return this.props.editingAdmin ? 'Edit Admin User' : 'Create Admin User';
  }

  getExhibitOptions() {
    let itemsToRender = this.props.locations ? this.props.locations : [];
    return itemsToRender.map(location => {
      return {value: location.id, label: `${location.name} - ${location.city}`}
    })
  }

  isEmailValid() {
    const matched = String(this.state.email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    return matched !== null;
  }

  isReadyToSubmit() {
    return this.isEmailValid() && this.state.firstName && this.state.lastName;
  }

  saveAdmin() {
    console.log(this.state.exhibits)
    if (this.isReadyToSubmit()) {
      if (this.props.editingAdmin) {
        this.props.saveAdmin({
          id: this.props.editingAdmin.id,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          role: this.state.role,
          exhibitIds: this.state.exhibits.map(e => e.value),
        })
      } else {
        this.props.saveAdmin({
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          email: this.state.email,
          role: this.state.role,
          exhibitIds: this.state.exhibits.map(e => e.value),
        })
      }
    }
  }

  render() {
    return (
      <div className={`edit-dialog ${this.props.show ? 'show' : ''}`}>
        <div className="content search">
          <div className="dialog-title">{this.getTitleText()}</div>
          <div className="fields">
            <div className="field">
              <div className="title">EMAIL</div>
              <input onChange={(event) => this.onFieldChange('email', event)} value={this.state.email} type="text" />
            </div>
            <div className="field">
              <div className="title">FIRST NAME</div>
              <input onChange={(event) => this.onFieldChange('firstName', event)} value={this.state.firstName} type="text" />
            </div>
            <div className="field">
              <div className="title">LAST NAME</div>
              <input onChange={(event) => this.onFieldChange('lastName', event)} value={this.state.lastName} type="text" />
            </div>
            <div className="field">
              <div className="title">ROLE</div>
              {/* <input onChange={(event) => this.onFieldChange('role', event)} value={this.state.role} type="text" /> */}
              <select value={this.state.role} onChange={(event) => this.onFieldChange('role', event)}>
                <option value={ROLES.ADMIN}>{ROLES.ADMIN}</option>
                <option value={ROLES.VIEWER}>{ROLES.VIEWER}</option>
              </select>
            </div>
            <div className={`field ${this.state.role == ROLES.ADMIN ? 'disable' : 'enable'}`}>
              <div className="title">EXHIBITS</div>
              <Select
                onChange={(event) => this.onMultiSelectChange('exhibits', event)}
                className="multi-select"
                isMulti
                value={this.state.exhibits}
                options={this.getExhibitOptions()}
              />
            </div>
          </div>
          <div className="bottom-buttons">
            <div onClick={this.saveAdmin.bind(this)} className={`action-button ${this.isReadyToSubmit() ? '' : 'disable'}`}>SAVE</div>
          </div>
          <img onClick={this.props.closeDialog.bind(this)} className="close" src={icClose}/>
        </div>
      </div>
    );
  }
}

export default AdminDialog;